import React, { useState } from "react";

function Base64Decoder() {
    const [base64Input, setBase64Input] = useState("");
    const [base64Result, setBase64Result] = useState("");
    const [error, setError] = useState("");

    const decodeBase64 = () => {
        try {
            setError(""); // Limpiar el error anterior
            const decoded = atob(base64Input);
            setBase64Result(decoded);
        } catch (e) {
            setError("Invalid Base64 input.");
            setBase64Result("");
        }
    };

    return (
        <div className="tool">
            <h2>Base64 Decoder</h2>
            <input
                type="text"
                value={base64Input}
                onChange={(e) => setBase64Input(e.target.value)}
                placeholder="Enter Base64 encoded text"
                aria-label="Base64 input"
            />
            <button onClick={decodeBase64}>Decode</button>
            <div className="result-container">
                {error && <p className="error-message">{error}</p>}
                {base64Result && <p>{base64Result}</p>}
            </div>
        </div>
    );
}

export default Base64Decoder;